export default function setupAnimationUtilities() {
  const triggerSettings = {
    start: "top 75%",
    // markers: true,
  };

  const dirMappings = [
    { name: "", settings: {} },
    { name: "--up", settings: { y: 20 } },
    { name: "--down", settings: { y: -20 } },
    { name: "--left", settings: { x: 20 } },
    { name: "--right", settings: { x: -20 } },
  ];

  // Add stagger animations
  dirMappings.forEach((mapping) => {
    const { name, settings } = mapping;

    gsap.utils.toArray(`.gsap-stagger${name}`).forEach((item) => {
      gsap.from(item.children, {
        autoAlpha: 0,
        stagger: { amount: 0.25 },
        duration: 0.6,
        ease: "power2.out",
        ...settings,
        scrollTrigger: {
          trigger: item,
          ...triggerSettings,
        },
      });
    });

    gsap.utils.toArray(`.gsap-fade${name}`).forEach((item) => {
      gsap.from(item, {
        autoAlpha: 0,
        duration: 0.6,
        ease: "power2.out",
        ...settings,
        scrollTrigger: {
          trigger: item,
          ...triggerSettings,
        },
      });
    });
  });

  // Add parallax scrolling effect for .gsap-parallax
  gsap.utils.toArray(".gsap-parallax").forEach((parallaxItem) => {
    const image = parallaxItem.querySelector("img");
    if (!image) return;

    gsap.to(image, {
      yPercent: -5,
      ease: "none",
      scrollTrigger: {
        trigger: parallaxItem,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.3,
      },
    });
  });

  // Add parallax effect for .pd-arch-left and .pd-arch-right wrappers
  gsap.utils.toArray(".pd-arch-left > figure, .pd-arch-right > figure").forEach((arch) => {
    const image = arch.querySelector("img");
    if (!image) return;

    gsap.to(image, {
      yPercent: -10,
      ease: "none",
      scrollTrigger: {
        trigger: arch,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.3,
      },
    });
  });

  // Reverse stagger animation for footer arches
  const arches = document.querySelectorAll(".pd-arches svg path");
  const totalArches = arches.length;

  arches.forEach((arch, index) => {
    gsap.from(arch, {
      autoAlpha: 0,
      y: "10%",
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: {
        trigger: arch,
        start: "top bottom",
        end: "bottom top",
      },
      delay: (totalArches - index - 1) * 0.2,
    });
  });

  // Split heading text into lines and apply a line mask effect
  document.querySelectorAll('.pd-heading-animation').forEach(parentBlock => {
    const headings = parentBlock.querySelectorAll('h1, h2, h3, h4, h5, h6');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: parentBlock,
        start: "top 75%",
        toggleActions: "play none none none",
      }
    });

    headings.forEach(heading => {
      const split = new SplitText(heading, { type: "lines", linesClass: "split-line" });

      split.lines.forEach(line => {
        const mask = document.createElement('div');
        mask.style.overflow = 'hidden';
        mask.style.display = 'block';
        mask.appendChild(line);
        heading.appendChild(mask);
      });

      const masks = heading.querySelectorAll('div');

      tl.fromTo(masks, {
        y: 20,
        opacity: 0,
      }, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        stagger: 0.1,
        ease: 'power2.out',
        onComplete: () => split.revert(),
      }, "-=0.4");
    });
  });
}